import { h, defineComponent } from 'vue';
import { Dialog } from '@phi/components';
import { update_with } from '@vaaas/fpts/object';
import {
    boolean_dialog_props as props,
    boolean_dialog_defaults as defaults,
} from '../../state/modals';

export default defineComponent({
    props: {
        show: { required: true, type: Boolean },
    },

    emits: {
        'update:show': (x: boolean) => true,
    },

    watch: {
        show(value: boolean) {
            if (!value)
                this.reset_defaults();
        },
    },

    methods: {
        onClose() {
            this.$emit('update:show', false);
            props.promise(false);
        },

        onConfirm() {
            this.$emit('update:show', false);
            props.promise(true);
        },

        onCancel() {
            this.$emit('update:show', false);
            props.promise(false);
        },

        reset_defaults() {
            update_with(defaults)(props);
        },
    },

    render() {
        return h(Dialog, {
            id: 'booleanDialog',
            title: props.title,
            show: this.show,
            'onUpdate:show': x => {
                if (!x) this.onCancel();
            },
            onConfirm: this.onConfirm,
            onClose: this.onCancel,
            confirm_label: props.ok,
            close_label: props.cancel,
        }, () => props.body);
    }
});
